export const ISSUE_GROUPS: string[] = [
  "Add-ons (ESD chains, Brushes)",
  "Batteries",
  "Booting, Initialization, Start, Restart",
  "Charging station",
  "Collisions & Traffic issues",
  "Docking & Positions",
  "E-stop & Proximity stop",
  "Handheld Controller",
  "Localization & Rgo",
  "Mecanum",
  "Memory (RAM, CPU, SSD)",
  "Navigation & Planning",
  "Network & Connection to the app",
  "Omnimove, shaking, sounds",
  "Rollers",
  "Sensors (Lidars, Cameras, IMU, Lift, CAN, RPM, Cables)",
  "Set up (Footprint, Network etc)",
  "SMCU & Safety stop"
];
